import gql from "graphql-tag";

export default gql`
  mutation deleteGraphicSet($customerId: ID, $graphicSetId: ID) {
    deleteGraphicSet(customerId: $customerId, graphicSetId: $graphicSetId) {
      id
    }
  }
`;
